import { defineStore } from 'pinia'
import { useCurrentUserStore } from './CurrentUserStore';
import { useTablePreferenceStore } from '@/pinia/TablePreferenceStore';
export const useReportingListStore = defineStore('ReportingList', {
    state: () => (
        {
            list: [],
            loading: false,
            pagination: {
                currentPage: 1,
                totalPageCount: 0,
                take: 25,
                skip: 0,
            },
            meta: {},
            totals: {},
            currencies: {},
            type: "",
            pre_type_url : "/reporting/",
            pre_labels: 'labels.reporting.table.',
            selectedCurrency: "",
            additionals: {},
            aborts: {
                load: new AbortController(),
                export: null,
                cache: new AbortController(),
            },
            preSelect: [],
        }),
    actions: {
        defaults(){
            this.type = "";
            this.pre_type_url = "/reporting/";
            this.pre_labels = "labels.reporting.table.";
            this.selectedCurrency = "";
            this.list = [];
            this.loading = false;
            this.pagination.currentPage = 1;
            this.pagination.totalPageCount = 0;
            this.pagination.skip = 0;
            this.pagination.totals = {};
        },
        async export(filter = []) {
            const tablePreferenceStore = useTablePreferenceStore();
            await tablePreferenceStore.tableIdent(this.type);
            var columns = tablePreferenceStore.getColumnsForIdent(this.type);
            const currentUser = useCurrentUserStore();
            return this.axios.post("/api/v1/" + currentUser.internal_company + this.pre_type_url + this.type, {
                take: this.pagination.take,
                skip: this.pagination.skip,
                columns: columns,
                pre_labels: this.pre_labels,
                export: true,
                selectedCurrency: this.selectedCurrency,
                filter: filter,
                additionals: this.additionals,
            }, { responseType: 'blob' });
        },
        async abortLoad() {
            this.aborts.load.abort();
        },

        async load(page = 1) {
            this.aborts.load.abort();
            this.aborts.load = new AbortController();
            this.loading = true;
            const tablePreferenceStore = useTablePreferenceStore();
            await tablePreferenceStore.tableIdent(this.type);
            var columns = tablePreferenceStore.getColumnsForIdent(this.type);
            if (!columns || (Array.isArray(columns) && columns.length === 0)) {
                let retries = 0;
                const maxRetries = 25;
                while ((!columns || (Array.isArray(columns) && columns.length === 0)) && retries < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                    columns = tablePreferenceStore.getColumnsForIdent(this.type);
                    retries++;
                }
            }
            const currentUser = useCurrentUserStore();
            this.pagination.skip = (page - 1) * this.pagination.take
            if (this.pagination.skip > this.pagination.total) {
                this.pagination.skip = 0;
            }
            return await this.axios.post("/api/v1/" + currentUser.internal_company + this.pre_type_url + this.type, {
                take: this.pagination.take,
                skip: this.pagination.skip,
                columns: columns,
                selectedCurrency: this.selectedCurrency,
                additionals: this.additionals,
            }, { signal: this.aborts.load.signal }).then((response) => {
                this.loading = false;
                this.list = response.data.data;
                if (response.data && response.data.meta && response.data.meta.pagination) {
                    this.setPagination(response.data.meta.pagination)
                }
                if (response.data && response.data.meta && response.data.meta.totals) {
                    this.totals = response.data.meta.totals;
                } else {
                    this.totals = {};
                }
                if (response.data && response.data.meta && response.data.meta.currencies) {
                    this.currencies = response.data.meta.currencies;
                } else {
                    this.currencies = {};
                }
                if (response.data && response.data.meta && response.data.meta.all_ids) {
                    this.preSelect = response.data.meta.all_ids;
                } else {
                    this.preSelect = [];
                }
                if(response?.data?.meta){
                    this.meta = response.data.meta;
                }else{
                    this.meta = {};
                }

                return response.data.data
            });
            this.loading = false;
        },
        async refreshCache(){
            this.aborts.cache.abort();
            this.aborts.cache = new AbortController();
            const tablePreferenceStore = useTablePreferenceStore();
            const currentUser = useCurrentUserStore();
            return await this.axios.post("/api/v1/" + currentUser.internal_company + this.pre_type_url + this.type, {
                take : this.pagination.take,
                skip : this.pagination.skip,
                selectedCurrency : this.selectedCurrency,
                refresh: true,
                }, {signal : this.aborts.cache.signal }).then((response) => {
                    if(response?.data?.meta){
                        this.meta = response.data.meta;
                    }else{
                        this.meta = {};
                    }
                    return response.data.data
                });
            },
        setPagination(object) {
            // this.meta.pagination = object;
            if (this.pagination.skip <= 0) {
                this.pagination.currentPage = 1;
            } else {
                this.pagination.currentPage = (this.pagination.skip / this.pagination.take) + 1;
            }
            this.pagination.totalPageCount = Math.ceil(object.total / this.pagination.take);
            this.pagination.total = object.total
        },
        updateSort(ident, except){
            var useIndex = this.columns.findIndex(item => item.id == this.use[ident]);
            for(let i in this.columns[useIndex].columns){
                if(this.columns[useIndex].columns[i].key == except){
                    this.columns[useIndex].columns[i].direction_pos = 0;
                }else{
                    this.columns[useIndex].columns[i].direction_pos += 1;
                }
            }
        },
    },
})
